export default __webpack_public_path__ + "static/media/de-logo-tall.509018f5.svg";